/**
 * Function that initializes all slick sliders, based on common class name
 **/
const initCarousels = () => {
    $(".slick-slider").not(".slick-initialized").slick();
    handleFeaturedCarousel();

    // remove the hidden styles from the content tiles carousel and content tile which applied before JS is loaded 
    $(".experience-commerce_assets-contenttilescarousel").show();
    $(".experience-commerce_assets-contenttile").show();
};

/**
* Handles the initialization and modification of the featured carousel.
* If the featured carousel exists and the window width is less than 768 pixels,
* it removes the first slide from the carousel.
*/
const handleFeaturedCarousel = () => {
    const featuredCarousel = $(".featured-carousel-wrapper .slick-slider");
    let firstSlide;

    if (featuredCarousel.length) {
        firstSlide = featuredCarousel.find(".slick-slide").first();
    }

    if (featuredCarousel && firstSlide && window.innerWidth < 768) {
        featuredCarousel.slick("slickRemove", 0);
    }
};

/**
 * Handles the custom slider behavior
 */
const handleCustomSlider = () => {
    $(".slick-slider").on("init", function () {
        const currentCarousel = $(this);
        centerArrowsOnImage(currentCarousel);
    });

    $(".slick-slider").on("reInit", function () {
        const currentCarousel = $(this);
        centerArrowsOnImage(currentCarousel);
    });
};

/**
* Vertically centers the arrows on the image for the given carousel
* @param {jQuery} currentCarousel - the current carousel element
* @returns {void}
*/
const centerArrowsOnImage = (currentCarousel) => {
    if (currentCarousel.hasClass("slick-slider-center-nav-on-image")) {
        const imageElement = currentCarousel.find(".image-container").length ? currentCarousel.find(".image-container") : currentCarousel.find(".content-tile__image-wrapper").last();
        const slideHeight = imageElement.height();
        currentCarousel.find(".slick-prev, .slick-next").css("top", slideHeight / 2);
    }
};

module.exports = {
    handleCustomSlider,
    initCarousels,
};
